import { apiName, apiUrl } from 'config';

import { Auth } from '@aws-amplify/auth';

const authV4 = {
    mandatorySignIn: true,
    // REQUIRED - Amazon Cognito Region
    region: process.env.USER_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.USR_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: process.env.USER_POOL_APP_CLIENT_ID,
};

// /** @type {import('@aws-amplify/core').AuthConfig} */
// const authV6 = {
//     Cognito: {
//         identityPoolId: undefined,
//         //  Amazon Cognito User Pool ID
//         userPoolId: process.env.USR_POOL_ID,
//         // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
//         userPoolClientId: process.env.USER_POOL_APP_CLIENT_ID, // NOTE: Development only for now. @JPC
//     },
// };

const apiV4 = {
    endpoints: [
        {
            name: apiName,
            endpoint: apiUrl,
            region: process.env.USER_REGION,
            custom_header: async () => {
                const headers = {};
                const session = await Auth.currentSession();
                headers['Authorization'] = `Bearer ${session
                    .getAccessToken()
                    .getJwtToken()} ${session
                    .getIdToken()
                    .getJwtToken()} ${session.getRefreshToken().getToken()}`;
                return headers;
            },
        },
    ],
};

// /** @type {import('@aws-amplify/core').APIConfig} */
// const apiV6 = {
//     REST: {
//         endpoints: [
//             {
//                 region: process.env.USER_REGION,
//                 name: apiName,
//                 endpoint: apiUrl,
//             },
//         ],
//     },
// };

export const amplifyConfigV4 = {
    Auth: authV4,
    API: apiV4,
};

// export const amplifyConfigV6 = {
//     Auth: authV6,
//     API: apiV6,
// };

// /** @type {Pick<import('@aws-amplify/core').LibraryOptions, 'API'} */
// export const amplifyLibOptionsV6 = {
//     API: {
//         REST: {
//             /**
//             @type {ReturnType<import('@aws-amplify/core/dist/esm/singleton/API/types').LibraryAPIOptions['REST']>}
//             */
//             headers: async () => {
//                 const session = await fetchAuthSession();
//                 return {
//                     // @ts-ignore
//                     Authorization: session?.tokens?.idToken.toString(),
//                 };
//             },
//         },
//     },
// };
